import React, { useState, useEffect } from 'react';
import axios from 'axios';

const fmt = (n) => n ? Number(n).toLocaleString('tr-TR') : '0';
const fmtTL = (n) => fmt(n) + ' TL';
const fmtTarih = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

const AYLAR = ['', 'Oca', 'Sub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Agu', 'Eyl', 'Eki', 'Kas', 'Ara'];

const StatKart = ({ baslik, deger, renk, alt }) => (
  <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '1rem 1.25rem' }}>
    <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>{baslik}</div>
    <div style={{ fontSize: '22px', fontWeight: '700', color: renk || '#111827' }}>{deger}</div>
    {alt && <div style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '2px' }}>{alt}</div>}
  </div>
);

const Bolum = ({ baslik, children }) => (
  <div style={{ marginBottom: '2rem' }}>
    <div style={{ fontSize: '13px', fontWeight: '600', color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '1rem', paddingBottom: '6px', borderBottom: '1px solid #F3F4F6' }}>
      {baslik}
    </div>
    {children}
  </div>
);

const MusteriRaporuPage = () => {
  const [musteriler, setMusteriler] = useState([]);
  const [seciliId, setSeciliId] = useState(null);
  const [rapor, setRapor] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [raporYukleniyor, setRaporYukleniyor] = useState(false);
  const [arama, setArama] = useState('');

  useEffect(() => {
    axios.get('/api/musteri-rapor')
      .then(r => { setMusteriler(r.data); setYukleniyor(false); })
      .catch(() => setYukleniyor(false));
  }, []);

  const musteriSec = (id) => {
    setSeciliId(id);
    setRaporYukleniyor(true);
    setRapor(null);
    axios.get('/api/musteri-rapor/' + id)
      .then(r => { setRapor(r.data); setRaporYukleniyor(false); })
      .catch(() => setRaporYukleniyor(false));
  };

  const filtrelenmis = musteriler.filter(m =>
    m.firma_adi.toLowerCase().includes(arama.toLowerCase())
  );

  // LİSTE
  if (!seciliId) {
    return (
      <div>
        <div style={{ marginBottom: '1.5rem' }}>
          <h2 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '4px' }}>Musteri Raporu</h2>
          <p style={{ fontSize: '13px', color: '#6B7280' }}>Musteri bazli detayli performans ve finansal raporlar</p>
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <input type="text" placeholder="Musteri ara..." value={arama} onChange={e => setArama(e.target.value)}
            style={{ width: '300px', padding: '8px 12px', border: '1px solid #E5E7EB', borderRadius: '8px', fontSize: '14px' }} />
        </div>

        {yukleniyor ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: '#6B7280' }}>Yukleniyor...</div>
        ) : (
          <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#F9FAFB' }}>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '600', color: '#6B7280' }}>Musteri</th>
                  <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: '600', color: '#6B7280' }}>Personel</th>
                  <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: '600', color: '#6B7280' }}>Toplam Gelir</th>
                  <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: '600', color: '#6B7280' }}>Toplam Maliyet</th>
                  <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: '600', color: '#6B7280' }}>Net Kar</th>
                  <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: '600', color: '#6B7280' }}>Kar Marji</th>
                  <th style={{ padding: '12px 16px' }}></th>
                </tr>
              </thead>
              <tbody>
                {filtrelenmis.map(m => {
                  const karMarji = m.toplam_gelir > 0 ? Math.round((m.net_kar / m.toplam_gelir) * 100) : 0;
                  return (
                    <tr key={m.id} style={{ borderTop: '1px solid #F3F4F6' }}>
                      <td style={{ padding: '12px 16px', fontWeight: '500' }}>
                        <div>{m.firma_adi}</div>
                        {m.sektor && <div style={{ fontSize: '11px', color: '#9CA3AF' }}>{m.sektor}</div>}
                      </td>
                      <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                        <span style={{ background: '#EEF2FF', color: '#4F46E5', padding: '2px 10px', borderRadius: '99px', fontWeight: '600' }}>{m.personel_sayisi}</span>
                      </td>
                      <td style={{ padding: '12px 16px', textAlign: 'right', color: '#059669', fontWeight: '600' }}>{fmtTL(m.toplam_gelir)}</td>
                      <td style={{ padding: '12px 16px', textAlign: 'right', color: '#DC2626' }}>{fmtTL(m.toplam_maliyet)}</td>
                      <td style={{ padding: '12px 16px', textAlign: 'right', fontWeight: '700', color: m.net_kar >= 0 ? '#059669' : '#DC2626' }}>
                        {m.net_kar >= 0 ? '+' : ''}{fmtTL(m.net_kar)}
                      </td>
                      <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                        <span style={{ background: karMarji >= 20 ? '#D1FAE5' : karMarji >= 0 ? '#FEF3C7' : '#FEE2E2', color: karMarji >= 20 ? '#059669' : karMarji >= 0 ? '#D97706' : '#DC2626', padding: '2px 10px', borderRadius: '99px', fontWeight: '600', fontSize: '12px' }}>
                          {karMarji}%
                        </span>
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        <button onClick={() => musteriSec(m.id)}
                          style={{ padding: '6px 14px', border: '1px solid #E5E7EB', borderRadius: '6px', background: '#fff', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>
                          Detay →
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }

  // DETAY
  return (
    <div>
      <button onClick={() => { setSeciliId(null); setRapor(null); }}
        style={{ padding: '8px 14px', border: '1px solid #E5E7EB', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '13px', marginBottom: '1.5rem' }}>
        ← Listeye Don
      </button>

      {raporYukleniyor && <div style={{ padding: '3rem', textAlign: 'center', color: '#6B7280' }}>Rapor hazirlaniyor...</div>}

      {rapor && (
        <div>
          {/* Başlık */}
          <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              <h2 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '4px' }}>{rapor.musteri.firma_adi}</h2>
              <p style={{ fontSize: '13px', color: '#6B7280' }}>{rapor.musteri.sektor || ''} {rapor.musteri.ulke ? '· ' + rapor.musteri.ulke : ''}</p>
            </div>
            <button onClick={() => (() => { const t = localStorage.getItem('token'); fetch('/api/pdf-rapor/musteri/' + seciliId, {headers:{Authorization:'Bearer '+t}}).then(r=>r.blob()).then(b=>{const a=document.createElement('a');a.href=URL.createObjectURL(b);a.download='musteri-raporu.pdf';a.click()}); })()}
              style={{ padding: '8px 16px', border: 'none', borderRadius: '8px', background: '#DC2626', color: '#fff', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
              PDF Indir
            </button>
          </div>

          {/* Finansal Özet */}
          <Bolum baslik="Finansal Ozet">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
              <StatKart baslik="Toplam Gelir" deger={fmtTL(rapor.finansal_ozet.toplam_gelir)} renk="#059669" />
              <StatKart baslik="Toplam Maliyet" deger={fmtTL(rapor.finansal_ozet.toplam_maliyet)} renk="#DC2626" />
              <StatKart baslik="Net Kar" deger={fmtTL(rapor.finansal_ozet.toplam_net_kar)} renk={rapor.finansal_ozet.toplam_net_kar >= 0 ? '#059669' : '#DC2626'} />
              <StatKart baslik="Kar Marji" deger={rapor.finansal_ozet.kar_marji + '%'} renk={rapor.finansal_ozet.kar_marji >= 20 ? '#059669' : '#F59E0B'} />
              <StatKart baslik="Fatura (KDV Dahil)" deger={fmtTL(rapor.finansal_ozet.toplam_fatura_kdv_dahil)} renk="#1a56db" />
              <StatKart baslik="Toplam KDV" deger={fmtTL(rapor.finansal_ozet.toplam_kdv)} renk="#6B7280" />
            </div>

            {/* Finansal Detay Tablo */}
            {rapor.finansal_detay.length > 0 && (
              <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
                <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid #F3F4F6', fontSize: '14px', fontWeight: '600' }}>Donem Bazli Finansal Detay</div>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead>
                      <tr style={{ background: '#F9FAFB' }}>
                        <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Donem</th>
                        <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Gelir</th>
                        <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Maliyet</th>
                        <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Net Kar</th>
                        <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Kar %</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rapor.finansal_detay.map((d, i) => {
                        const ayStr = d.ay || d.donem || '';
                        const ayNo = ayStr.includes('-') && !ayStr.includes('Q') ? parseInt(ayStr.split('-')[1]) : null;
                        const donemLabel = ayNo ? AYLAR[ayNo] + ' ' + ayStr.split('-')[0] : ayStr;
                        return (
                          <tr key={i} style={{ borderTop: '1px solid #F3F4F6' }}>
                            <td style={{ padding: '10px 16px', fontWeight: '500' }}>{donemLabel}</td>
                            <td style={{ padding: '10px 16px', textAlign: 'right', color: '#059669' }}>{fmtTL(d.gelir)}</td>
                            <td style={{ padding: '10px 16px', textAlign: 'right', color: '#DC2626' }}>{fmtTL(d.maliyet)}</td>
                            <td style={{ padding: '10px 16px', textAlign: 'right', fontWeight: '600', color: d.net_kar >= 0 ? '#059669' : '#DC2626' }}>
                              {d.net_kar >= 0 ? '+' : ''}{fmtTL(d.net_kar)}
                            </td>
                            <td style={{ padding: '10px 16px', textAlign: 'right' }}>
                              <span style={{ background: d.kar_marji >= 20 ? '#D1FAE5' : d.kar_marji >= 0 ? '#FEF3C7' : '#FEE2E2', color: d.kar_marji >= 20 ? '#059669' : d.kar_marji >= 0 ? '#D97706' : '#DC2626', padding: '2px 8px', borderRadius: '99px', fontSize: '12px', fontWeight: '600' }}>
                                {d.kar_marji}%
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </Bolum>

          {/* Personel */}
          <Bolum baslik={'Personel (' + rapor.personeller.length + ')'}>
            {rapor.personeller.length === 0 ? (
              <div style={{ padding: '2rem', textAlign: 'center', color: '#6B7280', background: '#F9FAFB', borderRadius: '12px' }}>Personel bulunamadi</div>
            ) : (
              <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead>
                      <tr style={{ background: '#F9FAFB' }}>
                        <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Personel</th>
                        <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Maliyet</th>
                        <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Fatura (KDV Haric)</th>
                        <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Fatura (KDV Dahil)</th>
                        <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Personel Kar</th>
                        <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Baslangic</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rapor.personeller.map((p, i) => (
                        <tr key={i} style={{ borderTop: '1px solid #F3F4F6' }}>
                          <td style={{ padding: '10px 16px' }}>
                            <div style={{ fontWeight: '500' }}>{p.ad} {p.soyad}</div>
                            <div style={{ fontSize: '11px', color: '#9CA3AF' }}>{p.email}</div>
                          </td>
                          <td style={{ padding: '10px 16px', textAlign: 'right', color: '#DC2626' }}>{p.maas ? fmtTL(p.maas) : '-'}</td>
                          <td style={{ padding: '10px 16px', textAlign: 'right' }}>{p.fatura_kalemi ? fmtTL(p.fatura_kalemi) : '-'}</td>
                          <td style={{ padding: '10px 16px', textAlign: 'right', color: '#059669', fontWeight: '600' }}>{p.fatura_kdv_dahil ? fmtTL(Math.round(p.fatura_kdv_dahil)) : '-'}</td>
                          <td style={{ padding: '10px 16px', textAlign: 'right', fontWeight: '600', color: p.personel_kar >= 0 ? '#059669' : '#DC2626' }}>
                            {p.personel_kar != null ? (p.personel_kar >= 0 ? '+' : '') + fmtTL(p.personel_kar) : '-'}
                          </td>
                          <td style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280' }}>{fmtTarih(p.outsource_baslangic || p.ise_giris_tarihi)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </Bolum>

          {/* Açık Kadrolar */}
          {rapor.acik_kadrolar.length > 0 && (
            <Bolum baslik={'Acik Kadrolar (' + rapor.acik_kadrolar.length + ')'}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {rapor.acik_kadrolar.map((k, i) => (
                  <div key={i} style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <div style={{ fontWeight: '500', fontSize: '14px' }}>{k.pozisyon}</div>
                      {k.departman && <div style={{ fontSize: '12px', color: '#9CA3AF' }}>{k.departman}</div>}
                      {k.aciklama && <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '2px' }}>{k.aciklama}</div>}
                    </div>
                    <div style={{ fontSize: '12px', color: '#9CA3AF', whiteSpace: 'nowrap' }}>{fmtTarih(k.olusturma_tarihi)}</div>
                  </div>
                ))}
              </div>
            </Bolum>
          )}

          {/* İşe Alım */}
          <Bolum baslik="Ise Alim">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
              <StatKart baslik="Toplam Aday" deger={rapor.isealim.toplam_aday} />
              <StatKart baslik="Tamamlanan" deger={rapor.isealim.tamamlanan} renk="#059669" />
              <StatKart baslik="Ort. Hiring Suresi" deger={rapor.isealim.ort_hiring_suresi + ' gun'} renk="#1a56db" />
              <StatKart baslik="Elenen" deger={rapor.isealim.elenme_sayisi} renk="#DC2626" />
            </div>

            {rapor.isealim.adaylar.length > 0 && (
              <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
                <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid #F3F4F6', fontSize: '14px', fontWeight: '600' }}>Aday Listesi</div>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead>
                      <tr style={{ background: '#F9FAFB' }}>
                        <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Aday</th>
                        <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Pozisyon</th>
                        <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Telefon</th>
                        <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Musteri</th>
                        <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Teklif</th>
                        <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Hiring</th>
                        <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Tarih</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rapor.isealim.adaylar.map((a, i) => (
                        <tr key={i} style={{ borderTop: '1px solid #F3F4F6' }}>
                          <td style={{ padding: '10px 16px', fontWeight: '500' }}>{a.ad} {a.soyad}</td>
                          <td style={{ padding: '10px 16px', color: '#6B7280' }}>{a.basvuru_pozisyon || '-'}</td>
                          <td style={{ padding: '10px 16px' }}>
                            <span style={{ background: a.telefon_durumu === 'gecti' ? '#D1FAE5' : a.telefon_durumu === 'elendi' ? '#FEE2E2' : '#F3F4F6', color: a.telefon_durumu === 'gecti' ? '#059669' : a.telefon_durumu === 'elendi' ? '#DC2626' : '#6B7280', padding: '2px 8px', borderRadius: '99px', fontSize: '11px' }}>
                              {a.telefon_durumu || 'Bekliyor'}
                            </span>
                          </td>
                          <td style={{ padding: '10px 16px' }}>
                            <span style={{ background: a.musteri_durumu === 'gecti' ? '#D1FAE5' : a.musteri_durumu === 'elendi' ? '#FEE2E2' : '#F3F4F6', color: a.musteri_durumu === 'gecti' ? '#059669' : a.musteri_durumu === 'elendi' ? '#DC2626' : '#6B7280', padding: '2px 8px', borderRadius: '99px', fontSize: '11px' }}>
                              {a.musteri_durumu || '-'}
                            </span>
                          </td>
                          <td style={{ padding: '10px 16px' }}>
                            <span style={{ background: a.teklif_durumu === 'evraklar_yuklendi' ? '#D1FAE5' : a.teklif_durumu === 'reddedildi' ? '#FEE2E2' : a.teklif_durumu ? '#EEF2FF' : '#F3F4F6', color: a.teklif_durumu === 'evraklar_yuklendi' ? '#059669' : a.teklif_durumu === 'reddedildi' ? '#DC2626' : a.teklif_durumu ? '#4F46E5' : '#6B7280', padding: '2px 8px', borderRadius: '99px', fontSize: '11px' }}>
                              {a.teklif_durumu || '-'}
                            </span>
                          </td>
                          <td style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280' }}>
                            {a.hiring_suresi_gun ? a.hiring_suresi_gun + ' gun' : '-'}
                          </td>
                          <td style={{ padding: '10px 16px', textAlign: 'right', color: '#9CA3AF', fontSize: '12px' }}>{fmtTarih(a.olusturma_tarihi)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </Bolum>

          {/* Kadro Talepleri */}
          {rapor.kadro_talepleri.length > 0 && (
            <Bolum baslik={'Kadro Talepleri (' + rapor.kadro_talepleri.length + ')'}>
              <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                  <thead>
                    <tr style={{ background: '#F9FAFB' }}>
                      <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Talep</th>
                      <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Pozisyon</th>
                      <th style={{ padding: '10px 16px', textAlign: 'center', color: '#6B7280', fontWeight: '600' }}>Adet</th>
                      <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Durum</th>
                      <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Tarih</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rapor.kadro_talepleri.map((k, i) => (
                      <tr key={i} style={{ borderTop: '1px solid #F3F4F6' }}>
                        <td style={{ padding: '10px 16px', fontWeight: '500' }}>{k.baslik}</td>
                        <td style={{ padding: '10px 16px', color: '#6B7280' }}>{k.pozisyon_adi || '-'}</td>
                        <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                          <span style={{ background: '#EEF2FF', color: '#4F46E5', padding: '2px 10px', borderRadius: '99px', fontWeight: '600' }}>{k.adet}</span>
                        </td>
                        <td style={{ padding: '10px 16px' }}>
                          <span style={{ background: k.durum === 'onaylandi' ? '#D1FAE5' : k.durum === 'reddedildi' ? '#FEE2E2' : '#FEF3C7', color: k.durum === 'onaylandi' ? '#059669' : k.durum === 'reddedildi' ? '#DC2626' : '#D97706', padding: '2px 8px', borderRadius: '99px', fontSize: '12px', fontWeight: '600' }}>
                            {k.durum}
                          </span>
                        </td>
                        <td style={{ padding: '10px 16px', textAlign: 'right', color: '#9CA3AF', fontSize: '12px' }}>{fmtTarih(k.olusturma_tarihi)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Bolum>
          )}
        </div>
      )}
    </div>
  );
};

export default MusteriRaporuPage;
